export default __webpack_public_path__ + "static/media/Agenda_Icon.564e6b27.svg";